/*

class to generate diagnosis

http://www.hl7.org/fhir/episodeofcare-definitions.html#EpisodeOfCare.diagnosis

[
  {
    "condition" : { Reference(Condition) }, // R!  Conditions/problems/diagnoses this episode of care is for
    "role" : { code }, // Role that this diagnosis has within the episode of care (e.g. admission, billing, discharge â€¦)
    "rank" : "<positiveInt>" // Ranking of the diagnosis (for each role type)
  }
]

*/
// Import libraries
const Joi = require('joi');

// Import variables
const { joiValidateObj } = require('../datastructComponents');
const { codeSchema } = require('./code.class');

// Create schema
const schema = {
  condition: Joi.string().required(),
  role: Joi.object().keys( codeSchema ).optional(),
  rank: Joi.number().integer().optional(),
};

// Define class
class Diagnosis {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Diagnosis = Diagnosis;
exports.diagnosisSchema = schema;